module.exports = __webpack_public_path__ + "../static/media/cs.d1495206.jpg";